import { RootState } from '../reducers/rootReducer';

export const projectSelector = (state: RootState) => {
	return state?.projects?.selectedProject;
};

export const projectSorterIndexSelector = (state: RootState) => {
	return state?.projects?.sorterIndex || 0;
};
